import { styled, Theme, Typography } from '@material-ui/core'

const SWITCH_WIDTH = 58

export const Wrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'space-between',
  fontSize: 20,
  marginBottom: theme.spacing(1.7),
  '& .MuiSwitch-root': {
    marginLeft: theme.spacing(2),
  },
  '& svg': {
    color: theme.palette.primary.main,
    minWidth: 20,
  },
}))

export const ContactInfo = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'space-between',
  '& p': {
    whiteSpace: 'nowrap',
    marginLeft: theme.spacing(),
  },
}))

export const InfoWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  width: `calc(100% - ${SWITCH_WIDTH}px)`,
  '& > p': {
    fontWeight: 600,
  },
})

export const TitleWrapper = styled('div')(({ theme }) => ({
  overflow: 'hidden',
  '& p': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginLeft: theme.spacing(1),
  },
}))

export const ContactValue = styled(Typography)(
  ({ theme, isActive }: { theme: Theme; isActive: boolean }) => ({
    color: isActive ? theme.palette.common.black : theme.palette.grey[400],
  })
)
